/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolFlashOnIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-flash-on"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M10.38 20.82Q10.38 20.82 10.24 20.77Q10.1 20.73 9.89 20.48Q9.68 20.23 9.68 19.88L9.68 14.57L8.95 14.57Q8 14.57 7.34 13.91Q6.67 13.25 6.67 12.3L6.67 4.33Q6.67 3.2 7.44 2.44Q8.2 1.68 9.32 1.68L14.93 1.68Q15.97 1.68 16.63 2.51Q17.27 3.35 16.93 4.33L15.72 7.67L17.1 7.67Q18.13 7.67 18.59 8.57Q19.05 9.47 18.48 10.3L11.47 20.43Q11.28 20.73 10.96 20.82Q10.65 20.93 10.38 20.82Z" fill={color} />
    </svg>
  );
}
